import metadrop from "../assets/metadrop.svg";
import buildspace from "../assets/buildspace.svg";
import ycombinator from "../assets/ycombinator.svg";
import polygon from "../assets/polygon.svg";
import sequoia from "../assets/sequoia.svg";

export const supportData = [
  {
    img: metadrop,
    alt: "metadrop",
  },
  {
    img: buildspace,
    alt: "buildspace",
  },
  {
    img: ycombinator,
    alt: "ycombinator",
  },
  {
    img: polygon,
    alt: "polygon",
  },
  {
    img: sequoia,
    alt: "sequoia",
  },
];
